import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import Card from "@amzn/meridian/card";
import { ConfirmItem } from "./confirmQuantityHelpers";

interface ItemCardProps {
  item: ConfirmItem;
  quantity: string;
  weight: string;
  onQuantityChange: (value: string) => void;
  onWeightChange: (value: string) => void;
  quantityError?: string;
  weightError?: string;
}

const ItemCard: React.FC<ItemCardProps> = ({
  item,
  quantity,
  weight,
  onQuantityChange,
  onWeightChange,
  quantityError,
  weightError,
}) => (
  <Card spacingInset="400">
    <Row alignmentVertical="top" spacing="300">
      {item.imageUrl && (
        <img
          src={item.imageUrl}
          alt={item.name}
          style={{ width: 60, height: 60, objectFit: "cover", flexShrink: 0 }}
        />
      )}
      <Column spacing="100" width="fill">
        <Text type="b300" color="primary">
          {item.name}
        </Text>
        {item.asin && (
          <Text type="b200" color="secondary">
            ASIN: {item.asin}
          </Text>
        )}
      </Column>
    </Row>

    <Row spacing="300" spacingInset="100">
      <Column spacing="100">
        <Text type="b200" color="secondary">
          Quantity
        </Text>
        <Input type="number" value={quantity} onChange={onQuantityChange} />
      </Column>
      <Column spacing="200">
        <Text type="b200" color="secondary">
          Weight
        </Text>
        <Input type="number" value={weight} onChange={onWeightChange} suffix={item.weightUnit} />
      </Column>
    </Row>

    {(quantityError || weightError) && (
      <Row spacingInset="300 none none">
        {quantityError && (
          <Text type="b200" color="error">
            {quantityError}
          </Text>
        )}
        {weightError && (
          <Text type="b200" color="error">
            {weightError}
          </Text>
        )}
      </Row>
    )}
  </Card>
);

export default ItemCard;
